<div class="row p-0 justify-content-center">
  <div class="col-2 col-sm-1 d-md-none d-lg-none"></div>
  <div class="col-8 col-sm-10 col-md-12 justify-content-center">
    <canvas class="scoreChart" id="{{ chartId }}"></canvas>
  </div>
  <div class="col-2 col-sm-1 d-md-none d-lg-none"></div>
  <div class="col-1 col-sm-1 d-md-none d-lg-none"></div>
  <div class="col-10 p-0">
    <hr
      class="d-md-none d-lg-none"
      style="
        stroke-width: 1px;
        stroke: var(--Secondary-Black-300, #e3e3e3);
        margin-top: 0px;
      "
    />
  </div>
  <div class="col-1 col-sm-1 d-md-none d-lg-none"></div>
</div>

<div
  class="modal fade"
  id="viewDetails"
  tabindex="-1"
  role="dialog"
  aria-labelledby="viewDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewDetailsLabel">What is Lorem Ipsum?</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry's standard dummy text ever
        since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book. It has survived not only five
        centuries, but also the leap into electronic typesetting, remaining
        essentially unchanged. It was popularised in the 1960s with the release
        of Letraset sheets containing Lorem Ipsum passages, and more recently
        with desktop publishing software like Aldus PageMaker including versions
        of Lorem Ipsum.
      </div>
    </div>
  </div>
</div>
